// Indian GST state / UT codes (as printed on a GSTIN's first two digits).
export const GST_STATES = [
  { code: "01", name: "Jammu & Kashmir" },
  { code: "02", name: "Himachal Pradesh" },
  { code: "03", name: "Punjab" },
  { code: "04", name: "Chandigarh" },
  { code: "05", name: "Uttarakhand" },
  { code: "06", name: "Haryana" },
  { code: "07", name: "Delhi" },
  { code: "08", name: "Rajasthan" },
  { code: "09", name: "Uttar Pradesh" },
  { code: "10", name: "Bihar" },
  { code: "11", name: "Sikkim" },
  { code: "12", name: "Arunachal Pradesh" },
  { code: "13", name: "Nagaland" },
  { code: "14", name: "Manipur" },
  { code: "15", name: "Mizoram" },
  { code: "16", name: "Tripura" },
  { code: "17", name: "Meghalaya" },
  { code: "18", name: "Assam" },
  { code: "19", name: "West Bengal" },
  { code: "20", name: "Jharkhand" },
  { code: "21", name: "Odisha" },
  { code: "22", name: "Chhattisgarh" },
  { code: "23", name: "Madhya Pradesh" },
  { code: "24", name: "Gujarat" },
  { code: "26", name: "Dadra & Nagar Haveli and Daman & Diu" },
  { code: "27", name: "Maharashtra" },
  { code: "29", name: "Karnataka" },
  { code: "30", name: "Goa" },
  { code: "31", name: "Lakshadweep" },
  { code: "32", name: "Kerala" },
  { code: "33", name: "Tamil Nadu" },
  { code: "34", name: "Puducherry" },
  { code: "35", name: "Andaman & Nicobar Islands" },
  { code: "36", name: "Telangana" },
  { code: "37", name: "Andhra Pradesh" },
  { code: "38", name: "Ladakh" },
  { code: "97", name: "Other Territory" },
];

export const emptyGst = { enabled: false, company: "", gstin: "", address: "", state: "" };

export const normalizeGstin = (v) => (v || "").replace(/\s/g, "").toUpperCase().slice(0, 15);

// Field-level check before we bother the backend (it owns the checksum + state-code rules).
export const gstClientError = (gst) => {
  if (!gst?.enabled) return null;
  if (!gst.company.trim()) return "Enter the company name.";
  if (normalizeGstin(gst.gstin).length !== 15) return "GSTIN must be exactly 15 characters.";
  if (!gst.address.trim()) return "Enter the company's billing address.";
  if (!gst.state) return "Select the company's state.";
  return null;
};

export const gstPayload = (gst) =>
  gst?.enabled
    ? {
        bill_to: "company",
        bill_to_company: gst.company.trim(),
        bill_to_gstin: normalizeGstin(gst.gstin),
        bill_to_address: gst.address.trim(),
        bill_to_state: gst.state,
        save_to_customer: true,
      }
    : { bill_to: "customer" };

// "Invoice will be issued to Acme Pvt Ltd · GSTIN 18AABCU9603R1ZM"
export const invoiceeLine = (company, gstin) =>
  company && gstin ? `Invoice will be issued to ${company} · GSTIN ${gstin}` : null;

// The backend's own message for an invalid GSTIN / checksum / state mismatch.
export const gstBackendError = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.message || d?.detail || "We couldn't validate that GSTIN. Please check and try again.";
};

// A 409 about billing (not the existing "dates just got booked" conflict).
export const billingConflict = (err) =>
  err?.response?.status === 409 &&
  /bill|gst|invoice/i.test(JSON.stringify(err?.response?.data?.detail ?? ""));
